import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { api } from "@/lib/api";

// Custom marker icon (coral pin)
const pinSvg = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 32' width='28' height='36'><path d='M12 0C5.4 0 0 5.4 0 12c0 8 12 20 12 20s12-12 12-20C24 5.4 18.6 0 12 0z' fill='%23FF6B57'/><circle cx='12' cy='12' r='4.5' fill='white'/></svg>`;
const anchorIcon = new L.Icon({ iconUrl: pinSvg, iconSize: [28, 36], iconAnchor: [14, 34], popupAnchor: [0, -30] });

function FitBounds({ ports }) {
  const map = useMap();
  useEffect(() => {
    if (ports.length) {
      const b = L.latLngBounds(ports.map(p => [p.lat, p.lng]));
      map.fitBounds(b, { padding: [30, 30] });
    }
  }, [ports, map]);
  return null;
}

export default function PortsMap({ onSelect, selected, height = 480 }) {
  const [ports, setPorts] = useState([]);

  useEffect(() => {
    api.get("/geo/ports").then(r => setPorts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="rounded-2xl overflow-hidden border border-[#0B1D3A]/10 shadow-[0_8px_32px_rgba(11,29,58,0.06)]" style={{ height }}>
      <MapContainer center={[40.0, -3.5]} zoom={6} style={{ height: "100%", width: "100%" }} scrollWheelZoom={true} data-testid="ports-map">
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://openstreetmap.org">OSM</a> &copy; <a href="https://carto.com">CARTO</a>'
        />
        <FitBounds ports={ports}/>
        {ports.map((p) => (
          <Marker key={`${p.province}-${p.name}`} position={[p.lat, p.lng]} icon={anchorIcon}
            eventHandlers={{ click: () => onSelect && onSelect(p) }}>
            <Popup>
              <div className="font-serif text-base">{p.name}</div>
              <div className="text-xs text-slate-500">{p.province}</div>
              {onSelect && (
                <button onClick={() => onSelect(p)} className="mt-2 text-xs px-3 py-1 bg-[#0B1D3A] text-white rounded-full" data-testid={`map-select-${p.name.replace(/\s+/g, '-')}`}>
                  {selected?.name === p.name ? "Seleccionado" : "Elegir este puerto"}
                </button>
              )}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
